                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SocketioService } from '../socket/socketio.service';


@Injectable({
  providedIn: 'root',
})
export class DirectDebitService {
  private url_la: any;
  private env: any = environment;

  constructor(
    public httpClient: HttpClient,
  ) {
    this.url_la = this.env.BASE_LA;
  }

  get baseUrl() {
    return this.url_la;
  }

  /* Retorna la información base de un proceso de domiciliación del día, para el banco y el tipo */
  getDirectDebitAlly = async (ally: string, type: string, date: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {
      ally,
      type,
      date
    };
    try {
      return lastValueFrom(
        this.httpClient.get<any>(this.baseUrl + '/api/direct_debit_alliances', {
          headers: headers,
          params: request,
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  /* Retorna la información base de un proceso de domiciliación del día, para el banco y el tipo */
  getDirectDebit = async (bank: string, type: string, date: any, productType?: string, specialFlow?: boolean): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request: any = {
      bank,
      type,
      date
    };

    // Si se proporciona productType, agregarlo a los parámetros
    if (productType) {
      request.product_type = productType;
    }

    // Flujo (estándar vs especial). El backend separa los lotes según este flag.
    request.special_flow = specialFlow === true ? 'true' : 'false';

    try {
      return lastValueFrom(
        this.httpClient.get<any>(this.baseUrl + '/api/direct_debit', {
          headers: headers,
          params: request,
        })
      );
    } catch (error) {
      console.error(error);
    }
  };


   /* Retorna la información base de un proceso de domiciliación del día, para el banco y el tipo */
   getDirectDebitAfiliation = async (bank: string, type: string, date: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {
      bank,
      type,
      date
    };
    try {
      return lastValueFrom(
        this.httpClient.get<any>(this.baseUrl + '/api/direct_debit/afiliation', {
          headers: headers,
          params: request,
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

   
  getDirectDebitConfig = async (bank: string, type: string, name: string): Promise<any> => {
      const headers = { 'content-type': 'application/json' };
      const request = {
        bank,
        type,
        name
      };
      try {
        return lastValueFrom(
          this.httpClient.get<any>(this.baseUrl + '/api/direct_debit/configs', {
            headers: headers,
            params: request,
          })
        );
      } catch (error) {
        console.error(error);
      }
  };

  /* Retorna toda la traza con la información por status de un proceso de domiciliación en base al id de direct_debit */
  getDirectDebitStatuses = async (direct_debit_id: string): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {
      direct_debit_id,
    };
    try {
      return lastValueFrom(
        this.httpClient.get<any>(
          this.baseUrl + '/api/direct_debit/direct_debit_status',
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  getDirectDebitAfiliationStatuses = async (direct_debit_id: string): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {
      direct_debit_id,
    };
    try {
      return lastValueFrom(
        this.httpClient.get<any>(
          this.baseUrl + '/api/direct_debit/direct_debit_status_afiliation',
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };


  cancel_direct_debit = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.put<any>(
          `${this.baseUrl}/api/direct_debit/direct_debit_cancel`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  direct_debit_manual_lote = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.put<any>(
          `${this.baseUrl}/api/direct_debit/direct_debit_manual_lote`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  

  
  update_rate_direct_debit = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.put<any>(
          `${this.baseUrl}/api/direct_debit_alliances/direct_debit_rate`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  finish_direct_debit_alliances = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.put<any>(
          `${this.baseUrl}/api/direct_debit_alliances/direct_debit_finish_alliances`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };


  finish_direct_debit = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.put<any>(
          `${this.baseUrl}/api/direct_debit/direct_debit_finish`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  


  cancel_direct_debit_trace = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.put<any>(
          `${this.baseUrl}/api/direct_debit/direct_debit_trace_cancel`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /* servicio que invoca al servicio que procesa y genera el txt que se envia al banco para la domiciliación de cuentas */
  startDirectDebitProcess = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit/start`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Pre-check (solo lectura) de lotes sin finalizar antes de "Iniciar".
   * params: { bankCode, type, product_type, target_date? }
   * Devuelve { success, count, lotes: [...] } con los lotes en status no-terminal.
   */
  precheckActiveLotes = async (params: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.httpClient.get<any>(
          `${this.baseUrl}/api/direct_debit/precheck_active_lotes`,
          { headers, params }
        )
      );
    } catch (error) {
      console.error(error);
      return { success: false, count: 0, lotes: [] };
    }
  };

  /**
   * Descarga (solo lectura) el Excel con los cobros del lote. Devuelve un Blob (.xlsx).
   */
  downloadLoteCobrosExcel = async (lote: string): Promise<Blob> => {
    return lastValueFrom(
      this.httpClient.get(`${this.baseUrl}/api/direct_debit/lote_cobros_excel`, {
        params: { lote },
        responseType: 'blob'
      })
    );
  };

  /**
   * Recupera un lote marcado como completado sin conciliar (completed=true -> false),
   * para que vuelva a quedar activo y se pueda conciliar. body: { id }
   */
  recoverLote = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.httpClient.put<any>(
          `${this.baseUrl}/api/direct_debit/recover_lote`,
          body,
          { headers, params: {} }
        )
      );
    } catch (error) {
      console.error(error);
      return { success: false };
    }
  };

  /**
   * Flujo especial de domiciliación (ex-domiciliados).
   * body: { type: 2 | 4, bankCode, product_type, user, cutoff_days: number | null }
   *   cutoff_days = null  → sin límite (todos los ex-domiciliados)
   *   cutoff_days = <N>   → solo los desactivados en los últimos N días
   */
  startDirectDebitSpecialProcess = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit/start_special`,
          body,
          { headers: headers, params: {} }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  startDirectDebitAllianceProcess = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit_alliances/start`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  pendingDirectDebit = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit/pending_domiciliation`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  saveDirectDebitStatus = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit/save_direct_debit_status`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  conciliarAlianza = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit_alliances/direct_debit_conciliation`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  // readDirectDebitFile = async (config: any, file: any): Promise<any> => {
  //   const headers = { 'content-type': 'multipart/form-data' };
  //   const form = new FormData();
  //   form.append('config', config);
  //   form.append('archivo', file);
  //   try {
  //    return lastValueFrom(
  //      this.httpClient.post<any>(
  //        `${this.baseUrl}/api/direct_debit/read_response_bank`,
  //        form,
  //        { headers: {} , params: {} }
  //      )
  //    );
  //   } catch (error) {
      
  //     console.error(error);
  //     return false;
  //   }
  //  };

  conciliar = async (body: any, file: any): Promise<any> => {
    const headers = { 'content-type': 'multipart/form-data' };
    const form = new FormData();
    form.append('obj', body);
    
    // Solo agregar archivo si existe (modo real)
    // En modo test, file será null
    if (file) {
      form.append('archivo', file);
    }

    const request = {};
    try {
      return await lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit/direct_debit_conciliation`,
          form,
          { headers: {} , params: {} }
        )
      );
    } catch (error: any) {
      console.error(error);
      // El backend puede rechazar la conciliación con 409 (precondiciones del día sin correr).
      // Se normaliza a { success:false, description } —el mismo shape que ya maneja el componente—
      // para que el operador vea el motivo real y no el error genérico.
      if (error?.error?.code) return error.error;
      throw error; // el resto de los errores mantiene el comportamiento anterior
    }
  };

  run_afiliations = async (body: any, file: any): Promise<any> => {
    const headers = { 'content-type': 'multipart/form-data' };
    const form = new FormData();
    form.append('obj', body);
    form.append('archivo', file);

    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit/direct_debit_run_afiliation`,
          form,
          { headers: {} , params: {} }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  pendingLote = async (productType?: string): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request: any = { };
    
    // Si se proporciona productType, agregarlo a los parámetros
    if (productType) {
      request.product_type = productType;
    }
    
    try {
      return lastValueFrom(
        this.httpClient.get<any>(
          this.baseUrl + '/api/direct_debit/pending_lote',
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };


  pendingLoteGeneric = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit_alliances/pending_lote`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
    
  };

  

  historic = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit/history`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  historic_aaliances = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit_alliances/history`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  historic_afiliations = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit/afiliations_history`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  generarReporte = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit/generate_excel`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  // `purpose` declara para qué se sube el archivo. Con 'conciliation' el backend valida las
  // precondiciones del día (backfill de mora) y responde 409 PRECONDITION_JOBS_MISSING antes de
  // parsear nada. Sin el flag no valida: lo usan el visor de cobros y las afiliaciones.
  // Nota: `return await` es necesario — sin él el catch no atrapa el rechazo del HttpClient.
  readDirectDebitFile = async (config: any, file: any, purpose?: string): Promise<any> => {
    const headers = { 'content-type': 'multipart/form-data' };
    const form = new FormData();
    form.append('config', config);
    form.append('archivo', file);
    if (purpose) form.append('purpose', purpose);
    try {
     return await lastValueFrom(
       this.httpClient.post<any>(
         `${this.baseUrl}/api/direct_debit/read_response_bank`,
         form,
         { headers: {} , params: {} }
       )
     );
    } catch (error: any) {
      console.error(error);
      // Se devuelve el cuerpo del error (trae code/description) para que el componente pueda
      // mostrarle al operador el motivo real en vez de un mensaje genérico.
      if (error?.error?.code) return error.error;
      return false;
    }
   };

   // Lector de cobros (SOLO LECTURA): resume cobros efectivos de registros ya parseados. No concilia.
   cobrosReport = async (data: any[], acron: string, enrich: boolean = true): Promise<any> => {
    try {
     return lastValueFrom(
       this.httpClient.post<any>(
         `${this.baseUrl}/api/direct_debit/cobros_report`,
         { data, acron, enrich },
         { headers: { 'content-type': 'application/json' } }
       )
     );
    } catch (error) {
      console.error(error);
      return false;
    }
   };

   // Registro de cobros desde archivo: consultar/validar el lote (solo lectura, sin archivo).
   cobrosArchivoLote = async (lote: string): Promise<any> => {
    try {
     return await lastValueFrom(
       this.httpClient.post<any>(
         `${this.baseUrl}/api/direct_debit/cobros_archivo_lote`,
         { lote },
         { headers: { 'content-type': 'application/json' } }
       )
     );
    } catch (error: any) {
      console.error(error);
      return error?.error ?? { ok: false, msg: error?.message || 'No se pudo conectar con el servidor.' };
    }
   };

   // Registro de cobros desde archivo (remediación): vista previa (solo lectura).
   cobrosArchivoPreview = async (lote: string, rows: any[]): Promise<any> => {
    try {
     return await lastValueFrom(
       this.httpClient.post<any>(
         `${this.baseUrl}/api/direct_debit/cobros_archivo_preview`,
         { lote, rows },
         { headers: { 'content-type': 'application/json' } }
       )
     );
    } catch (error: any) {
      console.error(error);
      return error?.error ?? { ok: false, msg: error?.message || 'No se pudo conectar con el servidor.' };
    }
   };

   // Registro de cobros desde archivo: registra 1 o N (idempotente en backend).
   cobrosArchivoRegistrar = async (lote: string, cobros: any[]): Promise<any> => {
    try {
     return await lastValueFrom(
       this.httpClient.post<any>(
         `${this.baseUrl}/api/direct_debit/cobros_archivo_registrar`,
         { lote, cobros },
         { headers: { 'content-type': 'application/json' } }
       )
     );
    } catch (error: any) {
      console.error(error);
      return error?.error ?? { ok: false, msg: error?.message || 'No se pudo conectar con el servidor.' };
    }
   };

   // Ver readDirectDebitFile: mismo contrato de `purpose` y mismo manejo del 409.
   readDirectDebitCustomFile = async (config: any, file: any, method: any, purpose?: string): Promise<any> => {
    const headers = { 'content-type': 'multipart/form-data' };
    const form = new FormData();
    form.append('method', method);
    form.append('config', config);
    form.append('archivo', file);
    if (purpose) form.append('purpose', purpose);
    try {
     return await lastValueFrom(
       this.httpClient.post<any>(
         `${this.baseUrl}/api/direct_debit/read_response_bank_custom`,
         form,
         { headers: {} , params: {} }
       )
     );
    } catch (error: any) {
      console.error(error);
      if (error?.error?.code) return error.error;
      return false;
    }
   };

   readDirectDebitFileXlsx = async (file: any): Promise<any> => {
    const headers = { 'content-type': 'multipart/form-data' };
    const form = new FormData();
    form.append('file', file);
    try {
     return lastValueFrom(
       this.httpClient.post<any>(
         `${this.baseUrl}/api/direct_debit_alliances/direct_debit_read_response`,
         form,
         { headers: {} , params: {} }
       )
     );
    } catch (error) {
      
      console.error(error);
      return false;
    }
   };
  


  downloadFile = (url: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      this.httpClient.get(url, { responseType: 'blob' }).subscribe(res => {
        const blob = new Blob([res], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);
        resolve(url);
      }, error => {
        resolve(null);
      });
    });
  }

  updatePaymentMethodCustomer = async (body: any, id: any): Promise<any> => {
    const headers = { };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.put<any>(
          `${this.baseUrl}/api/payment_method/customer?id=`+id,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  verifyAccounts = async (body: any): Promise<any> => {
    const headers = { };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.put<any>(
          `${this.baseUrl}/api/payment_method/verify_accounts`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Extensión REAL del archivo, deducida de la URL de Cloudinary.
   *
   * Las descargas venían con la extensión hardcodeada en la plantilla ('txt' casi siempre),
   * así que la respuesta de un banco que se sube en Excel —Bancaribe, por ejemplo— se
   * bajaba como .txt y se abría como binario ilegible.
   *
   * Cloudinary arma la ruta como .../<carpeta con el nombre original>/<public_id>. El
   * public_id final a veces conserva la extensión y a veces no (de 4.000 URLs guardadas,
   * 2.715 no la tienen), pero el nombre original sí quedó en el segmento de carpeta:
   *
   *   .../conciliaciones/respuesta_X.xlsx/gf3jnc635oq6odvl08zc.xlsx  -> xlsx  (último segmento)
   *   .../responses/report - 2026-06-01T123402.492.xls/ddozmrlpcyk9  -> xls   (carpeta)
   *   .../direct_debit/ef15d7dd-....txt.txt/vkalv76obo6pgug7fbkd     -> txt   (carpeta)
   *
   * Devuelve null si no reconoce ninguna extensión conocida, para que quien llame use
   * la que traía como respaldo y el comportamiento no cambie.
   */
  extensionRealDeUrl(url: string): string | null {
    if (!url) return null;
    const conocidas = ['txt', 'xls', 'xlsx', 'csv', 'dvr', 'pdf', 'zip'];
    try {
      const limpia = decodeURIComponent(String(url).split('?')[0]);
      const segmentos = limpia.split('/').filter(s => !!s);
      // Se mira primero el archivo y después la carpeta que carga el nombre original.
      const candidatos = [segmentos[segmentos.length - 1], segmentos[segmentos.length - 2]];
      for (const seg of candidatos) {
        if (!seg) continue;
        const punto = seg.lastIndexOf('.');
        if (punto === -1) continue;
        const ext = seg.slice(punto + 1).toLowerCase();
        if (conocidas.indexOf(ext) !== -1) return ext;
      }
    } catch (e) {
      console.error('extensionRealDeUrl:', e);
    }
    return null;
  }

  downloadImage(publicId: string, extension:string) {
    try{
    return lastValueFrom(
      this.httpClient.get(`${this.baseUrl}/api/direct_debit/download?public_id=${publicId}&ext=${extension}`, { responseType: 'blob' })
      );
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  cancel_direct_debit_afiliacion = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.put<any>(
          `${this.baseUrl}/api/direct_debit/direct_debit_afiliation_cancel`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };
  
  
   /* servicio que invoca al servicio que procesa y genera el txt que se envia al banco para la domiciliación de cuentas */
   startDirectDebitAfiliationProcess = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit/startAfiliation`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

 saveDirectDebitAfiliationStatus = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/direct_debit/save_direct_debit_afiliation_status`,
          body,
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };
  
  pendingLoteAfiliation = async (): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = { };
    try {
      return lastValueFrom(
        this.httpClient.get<any>(
          this.baseUrl + '/api/direct_debit/pending_lote_afiliation',
          { headers: headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };


   /* servicio que invoca al servicio que procesa y genera el txt que se envia al banco para la domiciliación de cuentas */
   reportAfiliationsErrors = async (): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {};
    try {
      return lastValueFrom(
        this.httpClient.get<any>(
          `${this.baseUrl}/api/direct_debit/afiliation_report_error`,
          { headers }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /* Obtiene información de la tasa según el tipo de producto */
  getProductRateInfo = async (productType: string): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const request = {
      product_type: productType
    };
    try {
      return lastValueFrom(
        this.httpClient.get<any>(
          `${this.baseUrl}/api/direct_debit/product_rate_info`,
          { headers, params: request }
        )
      );
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  /* Reinicia un trace cambiando su status a false */
  resetTrace = async (traceType: string, password: string): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const body = {
      trace_type: traceType,
      password: password
    };
    try {
      return lastValueFrom(
        this.httpClient.put<any>(
          `${this.baseUrl}/api/direct_debit/reset_trace`,
          body,
          { headers }
        )
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  /* ================================================================
   * MÓDULO: Desactivación de Domiciliación por Alta Morosidad
   * ================================================================ */

  getDeactivationBatches = async (page: number = 1, limit: number = 20, product_type?: string): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const params: any = { page, limit };
    if (product_type) params.product_type = product_type;
    try {
      return lastValueFrom(
        this.httpClient.get<any>(
          `${this.baseUrl}/api/v1/domiciliation-deactivation/batches`,
          { headers, params }
        )
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  getAffectedPersonsPaginated = async (batchId: string, page: number = 1, limit: number = 20, search: string = ''): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    const params: any = { page, limit };
    if (search) params.search = search;
    try {
      return lastValueFrom(
        this.httpClient.get<any>(
          `${this.baseUrl}/api/v1/domiciliation-deactivation/batches/${batchId}/persons`,
          { headers, params }
        )
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  getDeactivationBatchDetail = async (batchId: string): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.httpClient.get<any>(
          `${this.baseUrl}/api/v1/domiciliation-deactivation/batches/${batchId}`,
          { headers }
        )
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  exportDeactivationBatchCsv = (batchId: string): void => {
    const url = `${this.baseUrl}/api/v1/domiciliation-deactivation/batches/${batchId}/export-csv`;
    window.open(url, '_blank');
  };

  searchDeactivationByIdentity = async (identity: string): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.httpClient.get<any>(
          `${this.baseUrl}/api/v1/domiciliation-deactivation/search`,
          { headers, params: { identity } }
        )
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  runDeactivationManual = async (body: { product_types: string[] }): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.httpClient.post<any>(
          `${this.baseUrl}/api/v1/domiciliation-deactivation/run-manual`,
          body,
          { headers }
        )
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  /* Configuración de las alertas de domiciliación en Discord (pestaña "Alertas").
     El webhook vuelve enmascarado: solo se envía completo cuando se cambia. */
  getAlertsConfig = async (): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.httpClient.get<any>(`${this.baseUrl}/api/direct_debit/alerts_config`, { headers })
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  saveAlertsConfig = async (body: any): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.httpClient.put<any>(`${this.baseUrl}/api/direct_debit/alerts_config`, body, { headers })
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  /* Manda un mensaje marcado como prueba al canal, sin mencionar a nadie. */
  testAlertsWebhook = async (webhook_url?: string): Promise<any> => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.httpClient.post<any>(`${this.baseUrl}/api/direct_debit/alerts_config/test`, { webhook_url }, { headers })
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

}
